import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';

export type UnsavedChangesDecision = 'save' | 'discard' | 'cancel';

@Component({
    selector: 'app-unsaved-changes-dialog',
    standalone: true,
    imports: [MatDialogModule, MatButtonModule, TranslatePipe],
    templateUrl: './unsaved-changes-dialog.component.html',
    styleUrl: '../save-confirmation-dialog/save-confirmation-dialog.component.scss'
})
export class UnsavedChangesDialogComponent { }
